/**
* Blog Roll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Blog Roll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'blog-roll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mqLg = window.matchMedia( '(min-width: 1024px)' );
      const mqXl = window.matchMedia( '(min-width: 1270px)' );

      const equalizeBlogRollHeights = () => {
        const containers = document.querySelectorAll( '.blog-roll .post__content-container' );
        if ( !containers.length ) return;

        // Reset heights first for proper measurement
        containers.forEach( ( c ) => c.style.height = 'auto' );

        // Only equalize heights when at least 1024px
        if ( mqLg.matches ) {
          const tallest = Math.max( ...[...containers].map( ( c ) => c.offsetHeight ) );
          containers.forEach( ( c ) => c.style.height = `${tallest}px` );
        }
      };

      const setupBlogRollEqualizer = () => {
        equalizeBlogRollHeights();

        // Re-run when crossing either breakpoint
        mqLg.addEventListener( 'change', equalizeBlogRollHeights );
        mqXl.addEventListener( 'change', equalizeBlogRollHeights );

        // Re-run when images load (avoids incorrect measuring)
        document.querySelectorAll( '.blog-roll img' ).forEach( ( img ) =>
          img.addEventListener( 'load', equalizeBlogRollHeights, {once: true} ),
        );
      };

      window.addEventListener( 'load', setupBlogRollEqualizer );

      window.addEventListener( 'imagesLoaded', equalizeBlogRollHeights );
      document.querySelectorAll( 'img' ).forEach( ( img ) =>
        img.addEventListener( 'load', equalizeBlogRollHeights, {once: true} ),
      );

      mqLg.removeEventListener?.( 'change', equalizeBlogRollHeights );
      mqXl.removeEventListener?.( 'change', equalizeBlogRollHeights );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'blog-roll', COMPONENT );
} )( app );
